export const API = {
  HOST: process.env.REACT_APP_API_HOST || "",
  KEY: process.env.REACT_APP_API_KEY || "",
};